'use strict';
var userAgent = require('../internals/environment-user-agent');

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/internals/environment-is-ios.js
// module id = 241
// module chunks = 13